import React, { useEffect } from 'react';
import ManifestEventLog from './ManifestEventLog';
import { ManifestLogEvent } from '../../models/manifest';
import { Button } from '@cimpress/react-components';
import { ManifestActions } from './ManifestActions';
import { useModal } from '../../contexts/modal-context';
import { FlexBox, JustifyContent } from '../../utils/css-classes';

interface Props {
  manifestId: string;
  manifestEventLog: ManifestLogEvent[];
  lastUpdated: Date | undefined;
  loading: boolean;
  loadManifestEventLog: (manifestId: string) => void;
}

function formatDate(date?: Date): string {
  return date && date.toISOString() || 'never';
}
// tslint:disable-next-line:function-name
export default function ManifestEventLogPage({
  manifestId,
  manifestEventLog,
  loadManifestEventLog,
  lastUpdated,
  loading,
}: Props) {
  useEffect(
    () => {
      loadManifestEventLog(manifestId);
    },
    [manifestId],
  );

  const modal = useModal();

  const lastUpdatedComponent = (<p>Last updated {formatDate(lastUpdated)}</p>);
  return (
    <div className="">
      <div className="page-title">
        <div className="h1">Manifest Event Log <i>{manifestId}</i></div>
        {lastUpdated && lastUpdatedComponent}
      </div>
      <div>
        <div className={`my-4 ${FlexBox.FLEX} ${JustifyContent.FLEX_END}`}>
          <Button
            type="primary"
            onClick={
              () => modal(
                'Manifest actions',
                hide => <ManifestActions hide={hide} manifestId={manifestId} />,
                {},
              )
          }>
            Actions
          </Button>

        </div>
        <ManifestEventLog data={manifestEventLog} loading={loading} />
      </div>
    </div>
  );
}
